export *  from './msw-product-claims.route';
export *  from './msw-product-claims.store';

export { default as MswProductClaimsModule } from './msw-product-claims.store';
export { default as MswProductClaimsRoute } from './msw-product-claims.route';
